import FormattedLink from './FormattedLink.js';
import MobileText from './MobileText.js';

import Footer from './MobileFooter.js';

const MobileView = (props) => {
  return (
    <div>
      <link rel="stylesheet" href="https://use.typekit.net/hau2shn.css"></link>
      <div style={{
        backgroundColor: "#77a632",
        minHeight: "160px",
        display: "flex"
      }}>
        <div style={{ flexBasis: "15%"}} />
        <div>
          <div style={{
            fontFamily: "ff-scala",
            fontSize: "48px",
            color: "white",
            paddingTop: "30px"
          }}>
            Bram Meehan
          </div>
          <div style={{
            maxWidth: "600px",
            fontFamily: "ff-scala",
            fontSize: "22px",
            color: "#3b4539",
            overflowWrap: 'break-word',
            paddingRight: "30px"
          }}>
            {props.introText}
          </div>
        </div>
      </div>
      <div style={{
        backgroundColor: "white",
        display: "flex"
      }}>
        <div style={{ flexBasis: "15%"}} />
        <div>
          <FormattedLink text="Design, Writing, + Direction" link="https://www.designwritingdirection.com/" customFontSize="18px"/>
          <MobileText text={props.dwdText} />
          <FormattedLink text="Bram Letters" link="https://www.bramletters.com/"  customFontSize="18px"/>
          <MobileText text={props.bramLettersText} />
          <FormattedLink text="7000 BC" link="https://www.7000bc.org/"  customFontSize="18px"/>
          <MobileText text={props.bcText} />
          <FormattedLink text="New Mexico Fencing Foundation" link="https://www.nmfencing.org/"  customFontSize="18px"/>
          <MobileText text={props.bramFencingText} />
          <FormattedLink text="Cause for Design" link="https://causefor.design/" customFontSize="18px"/>
          <MobileText text={props.bramCorpsText} />
          <FormattedLink text="Polaroid Photography" link="https://brammeehan.photo" displayValue="inline-block" customFontSize="18px"/>
          <MobileText text={props.polaroidText} />
          <FormattedLink text="Mastodon" link="https://ohai.social/@BramMeehan" rel="me" displayValue="inline-block" customFontSize="18px"/>
          <MobileText text={props.mastodonText} />
          <FormattedLink text="Facebook" link="https://facebook.com/bram.meehan/" displayValue="inline-block" padding="14px"  customFontSize="18px"/>
          <div style={{
            fontFamily: "ff-scala",
            fontSize: "16px",
            color: "#3b4539",
            paddingLeft: "9px",
            paddingRight: "9px",
            paddingTop: "20px",
            display: "inline"
          }}>
            |
          </div>
          <FormattedLink text="Instagram" link="https://www.instagram.com/brammeehan/" displayValue="inline-block" padding="14px"  customFontSize="18px"/>
          <div style={{
              fontFamily: "ff-scala",
              fontSize: "16px",
              color: "#3b4539",
              paddingLeft: "9px",
              paddingRight: "9px",
              paddingTop: "20px",
              display: "inline"
            }}>
            |
          </div>
          <FormattedLink text="LinkedIn" link="https://www.linkedin.com/in/brammeehan/" displayValue="inline-block" padding="14px"  customFontSize="18px"/>
          <MobileText text={props.somedText} />
          <div style={{ 
              borderTop: "2px solid #7EA143 ", 
              marginLeft: 0, 
              marginRight: 20, 
              marginTop: 20,
             }} >
          </div>
          <Footer />
        </div>
      </div>
    </div>
  )
}

export default MobileView;